import { GenerateSubSelector } from '../spaceKeyedSelectors';
import { ICatalogTypesState } from './CatalogTypesReducer';

export const SelectCatalogTypesState = GenerateSubSelector<ICatalogTypesState>('catalogTypes');
